import Layout from "./components/Layout.vue";
import Painel from "./components/Painel.vue";
import ListaProjetos from "./components/ListaProjetos.vue";
import AssistenteProjeto from "./components/AssistenteProjeto.vue";
import DetalheProjeto from "./components/DetalheProjeto.vue";
import MensuracaoProjeto from "./components/MensuracaoProjeto.vue";
import PdmGestao from "./components/PdmGestao.vue";
import Relatorios from "./components/Relatorios.vue";
import Configuracoes from "./components/Configuracoes.vue";
import PainelPublico from "./components/PainelPublico.vue";
import PainelPublicoApresentacao from "./components/PainelPublicoApresentacao.vue";

export const routes = [
  {
    path: "/painel-publico-projetos",
    name: "gestao-projetos.publico",
    component: PainelPublico,
  },
  {
    path: "/painel-publico-projetos-apresentacao",
    name: "gestao-projetos.publico.apresentacao",
    component: PainelPublicoApresentacao,
  },
  {
    path: "/gestao-projetos",
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      { path: "", redirect: { name: "gestao-projetos.painel" } },
      { path: "painel", name: "gestao-projetos.painel", component: Painel },
      { path: "pdm", name: "gestao-projetos.pdm", component: PdmGestao },
      {
        path: "pdm/:idPdm/editar",
        name: "gestao-projetos.pdm.editar",
        component: PdmGestao,
      },
      {
        path: "pdm/:idPdm/excluir",
        name: "gestao-projetos.pdm.excluir",
        component: PdmGestao,
      },
      {
        path: "projetos",
        name: "gestao-projetos.projetos",
        component: ListaProjetos,
      },
      {
        path: "projetos/novo",
        name: "gestao-projetos.novo",
        component: AssistenteProjeto,
      },
      {
        path: "projetos/:idProjeto",
        name: "gestao-projetos.detalhe",
        component: DetalheProjeto,
        props: true,
      },
      {
        path: "projetos/:idProjeto/excluir",
        name: "gestao-projetos.excluir",
        component: DetalheProjeto,
        props: true,
      },
      {
        path: "projetos/:idProjeto/mensuracao",
        name: "gestao-projetos.mensuracao",
        component: MensuracaoProjeto,
        props: true,
      },
      {
        path: "projetos/:idProjeto/editar",
        name: "gestao-projetos.editar",
        component: AssistenteProjeto,
        props: true,
      },
      {
        path: "relatorios",
        name: "gestao-projetos.relatorios",
        component: Relatorios,
      },
    ],
  },
];
